var _g, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewspaperDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4_25044)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 27,
    height: 27,
    rx: 13.5,
    fill: "#3152E7"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0, 4)",
    d: "M20.666 8.75033H23.041C23.251 8.75033 23.4523 8.83373 23.6008 8.9822C23.7493 9.13067 23.8327 9.33203 23.8327 9.54199V18.2503C23.8327 18.6703 23.6659 19.073 23.3689 19.3699C23.072 19.6668 22.6693 19.8337 22.2493 19.8337M22.2493 19.8337C21.8294 19.8337 21.4267 19.6668 21.1298 19.3699C20.8328 19.073 20.666 18.6703 20.666 18.2503V7.95866C20.666 7.7487 20.5826 7.54733 20.4341 7.39887C20.2857 7.2504 20.0843 7.16699 19.8743 7.16699H11.9577C11.7477 7.16699 11.5464 7.2504 11.3979 7.39887C11.2494 7.54733 11.166 7.7487 11.166 7.95866V17.4587C11.166 18.0885 11.4162 18.6926 11.8616 19.138C12.307 19.5834 12.9111 19.8337 13.541 19.8337H22.2493Z",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0, 4)",
    d: "M14.334 10.333H17.5007",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0, 4)",
    d: "M14.334 13.5H17.5007",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(0, 4)",
    d: "M14.334 16.667H17.5007",
    stroke: "white",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4_25044",
    x: 0,
    y: 0,
    width: 35,
    height: 35,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4_25044"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4_25044",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewspaperDashboardIcon);
export default __webpack_public_path__ + "static/media/newspaper-dashboard-icon.26d90f8d41ce39445df25dccd582a6b0.svg";
export { ForwardRef as ReactComponent };